export const formatLastUpdated = (dateString) => {
  if (!dateString) {
    return null;
  }

  const date = new Date(dateString);
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString(undefined, options);
};